import React from 'react'
import { Checkmark32, MisuseOutline32 } from '@carbon/icons-react'

const StatusColumnFramework = ({ value: enabled }) => {
  return (
    <div className='scenario-status__column'>
      {enabled ? (
        <Checkmark32 className='scenario-status__icon--enabled' />
      ) : (
        <MisuseOutline32 className='scenario-status__icon--disabled' />
      )}
    </div>
  )
}

export default StatusColumnFramework
